"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6871],{

/***/ 36871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45002);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(349);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70641);
/* harmony import */ var _helpers_queryParams__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17706);




var MaintenanceBanner = function() {
    var maintenance_start_time_local = (0,_helpers_queryParams__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().maintenance_start_time_local;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(maintenance_start_time_local !== undefined), showBanner = ref[0], setShowBanner = ref[1];
    var closeBanner = function() {
        return setShowBanner(false);
    };
    if (!showBanner) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
        py: "$4",
        px: "$6",
        backgroundColor: "$backgroundStateErrorSecondary",
        mx: "auto",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "p",
                typography: "$bodyMedium",
                fontWeight: "$medium",
                flexGrow: 1,
                textAlign: "center",
                $largerThanMD: {
                    typography: "$bodyLarge"
                },
                children: [
                    "Opendoor will be down for scheduled maintenance on ",
                    maintenance_start_time_local
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .CloseButton */ .PZ, {
                size: "small",
                onPress: closeBanner,
                id: "maintenance-banner-close-button",
                iconLabel: "Close banner",
                analyticsName: "cosmos-maintenance-banner-close",
                alignSelf: "center"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MaintenanceBanner);


/***/ })

}]);